import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import { AddIcon } from '@/resources/icons';
import { openDrawer } from '@/state/actions';
import { useDispatch } from 'react-redux';
import useStyles from './styles';

/**
 * Create Tag Button to open CreateTagsDrawer
 * @param {type} type the type for the item is contained in this parent drawer (product, service, etc)
 * @param {object} item the item that the drawer is open for (product, service, etc)
 * @param {object} currentValues the current responses in the drawer's input fields
 * @param {string} title the title for client drawer that will need to be passed back with an update
 * @param {boolean} edit whether or not user is updating the item in drawer
 * @returns
 */

const CreateTagButton = ({ type, item, currentValues, title, edit }) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const handleOpenCreateTags = () => {
        dispatch(
            openDrawer({
                id: 'createTags',
                type,
                item,
                currentValues,
                title,
                edit,
                currentTags: currentValues.tags,
                openedFromDrawer: type
            })
        );
    };

    return (
        <Button
            variant="contained"
            fullWidth
            className={classes.createTagsButton}
            startIcon={<AddIcon className={classes.createTagsIcon} />}
            onClick={handleOpenCreateTags}
        >
            Create New Tag
        </Button>
    );
};

CreateTagButton.propTypes = {
    type: PropTypes.string,
    item: PropTypes.object,
    currentValues: PropTypes.object,
    title: PropTypes.string,
    edit: PropTypes.bool
};

CreateTagButton.defaultProps = {
    type: undefined,
    item: undefined,
    currentValues: undefined,
    title: undefined,
    edit: false
};

export default CreateTagButton;
